import { Box, Image as ChakraImage } from "@chakra-ui/react";
import Head from "next/head";
import Link from "next/link";
import React from "react";
import * as S from "../../styles/SellingForUsers";

function SellingForOwners() {
  return (<>
    <Head>
      <title key="title">Selling on Zonado for Owners</title>
      <meta
        key="description"
        name="description"
        content="Learn about the key benefits of using Zonado when you’re looking to sell your business or property independently. "
      />
      <meta
        key="og:title"
        property="og:title"
        content="Selling on Zonado for Owners"
      />
      <meta
        key="og:description"
        property="og:description"
        content="Learn about the key benefits of using Zonado when you’re looking to sell your business or property independently. "
      />
    </Head>
    <S.SellingForUsersPageWrapper>
      <S.BannerImageContainer
        imageUrl={"/images/selling/owners/selling-for-owners.jpg"}
      >
        <S.BannerHeadingText>
          Selling on Zonado for Owners
        </S.BannerHeadingText>
        <S.BannerBlurb>
          Learn about the key benefits of using Zonado when you’re looking to
          sell your business or property independently.
        </S.BannerBlurb>
      </S.BannerImageContainer>

      <S.Text>
        As an independent owner, you should have the right tools, and network
        to sell your asset on your own - should you decide to do so.
      </S.Text>
      <S.Text>
        Some of Zonado’s most glowing reviews have come from independent
        owners who had grown tired of using other means to sell their listing
        before they found Zonado. They were blown away by the level of
        individualized service and attention they received from Zonado, in
        addition to the focused exposure and interest their asset received
        from investors and professionals across the country which ultimately
        helped them sell on their own terms.
      </S.Text>

      <S.HeadingText>Benefits of Selling on Zonado</S.HeadingText>
      <S.Text>
        Zonado is where people can discover, buy and sell commercial real
        estate and businesses for sale. Here are some of the benefits of
        selling or listing your property or business on Zonado as an owner.
      </S.Text>

      <S.SubHeadingText>
        The chance to reach an active, focused community
      </S.SubHeadingText>
      <S.SubHeadingDescription>
        When you list on Zonado, you get access to a growing community of
        active, motivated buyers from across Canada. Each month, thousands of
        people are browsing and buying properties and businesses on Zonado.
        They love Zonado because they avoid the clutter of classifieds
        platforms and can find the right listing a lot quicker. With Zonado,
        independent owners have the opportunity to reach a community from
        which they were previously left out.
      </S.SubHeadingDescription>

      <S.SubHeadingText>
        The leads are completely free
      </S.SubHeadingText>
      <S.SubHeadingDescription>
        Unlike every other listing platform in the industry. Taking Zonado on
        a test drive costs nothing at all. Submitting your listing is
        completely free - and so are your inquiries (from verified
        users).     
      </S.SubHeadingDescription>

      <S.SubHeadingText>Ease of Use</S.SubHeadingText>
      <S.SubHeadingDescription>
        Zonado was built with people in mind. It’s fast and simple to use. As
        an owner, you can{" "}
        <S.LinkText href="https://zonado.com/add-listing">
          create a new listing
        </S.LinkText>{" "}
        in a matter of minutes, respond to inquiries within a few seconds and
        update listing availability within moments.{" "}
      </S.SubHeadingDescription>

      <S.SubHeadingText>Real-Time Communication</S.SubHeadingText>
      <S.SubHeadingDescription>
        On Zonado, you can engage directly with interested buyers using Zonado
        Messaging. When a buyer is interested in your listing, they can use
        Zonado Messaging to reach out directly to you with any questions or
        concerns they might have. Send multiple files, see whether your
        message has been read and get SMS alerts whenever you have a new
        message so you never miss an inquiry.
      </S.SubHeadingDescription>

      <S.SubHeadingText>Advanced Analytics</S.SubHeadingText>
      <S.SubHeadingDescription>
        Sellers on Zonado get detailed insights about their listing’s
        performance. See who has been engaging with the listing the most to
        find promising prospects. Know who has interacted with your listing
        flyer and the number of visits your listing has received from Zonado.
      </S.SubHeadingDescription>

      <Box my="70px">
        <ChakraImage src="/images/selling/professionals/dashboard-screenshot.png" />
      </Box>

      <S.HeadingText>Promoting Your Listings</S.HeadingText>
      <S.Text>
        As a professional, you can promote listings and increase exposure in
        one of two ways on Zonado:
      </S.Text>

      <S.SubHeadingText>Sharing Listings Organically</S.SubHeadingText>
      <S.SubHeadingDescription>
        One great way to get your listing in front of more interested buyers
        is by simply sharing your listing on your social media profiles and
        pages, posting about it in groups you’ve joined or emailing it to your
        mailing list.
      </S.SubHeadingDescription>

      <S.SubHeadingText>Boosting Listings</S.SubHeadingText>
      <S.SubHeadingDescription>
        Another way to increase visibility on your listing is by boosting it
        after it has been created. Boosting your Zonado listing gives it up to
        20 times more exposure on the platfrom and helps you rise above the
        crowd. Contact{" "}
        <S.LinkText href="mailto:hello@zonado.com">
          hello@zonado.com
        </S.LinkText>{" "}
        to learn how to boost your listing.
      </S.SubHeadingDescription>

      <S.BannerImageContainer
        imageUrl="/images/selling/professionals/footer-image.jpg"
        style={{
          marginTop: "100px",
        }}
      >
        <S.BannerHeadingText>Buy or sell on Zonado</S.BannerHeadingText>
        <Link href="https://zonado.com">

          <S.CTAButton>Go to Zonado</S.CTAButton>

        </Link>
      </S.BannerImageContainer>
    </S.SellingForUsersPageWrapper>
  </>);
}

SellingForOwners.newLayout = true;

export default SellingForOwners;
